module.exports = __webpack_public_path__ + "img/emoji_19.2d844849.png";